import { useState } from "react";
import MissionWater from "./MissionWater";
import MissionQuality from "./MissionQuality";
import MissionIssue from "./MissionIssue";
import { useNavigate } from "react-router-dom";
import MissionServiceAvizeau from "./MissionServiceAvizeau";

const MissionNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("eau");
  const navigate = useNavigate();
  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/missions?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center mt-5 ">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base   ${
              activeSection === "eau"
                ? "text-black font-bold   text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("eau")}
          >
            Eaux usées
            <hr
              className={
                activeSection === "eau" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "traiter"
                ? "text-black font-bold  text-xs md:text-base   "
                : ""
            }`}
            onClick={() => handleSectionChange("traiter")}
          >
            Traiter
            <hr
              className={
                activeSection === "traiter" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "protéger-l-environnement"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("protéger-l-environnement")}
          >
            Protéger l’environnement
            <hr
              className={
                activeSection === "protéger-l-environnement"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base  ${
              activeSection === "rénover"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("rénover")}
          >
            Rénover
            <hr
              className={
                activeSection === "rénover" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-[480px] max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "eau" && <MissionWater />}
      {activeSection === "traiter" && <MissionQuality />}
      {activeSection === "protéger-l-environnement" && <MissionIssue />}
      {activeSection === "rénover" && <MissionServiceAvizeau />}
    </>
  );
};

export default MissionNavigationMenu;
